import { IUser } from "../../../../../context/interfaces/User";

const adaptRightTitle = (val?: string) => (val || "").trim().toLowerCase();

export const canUserEditDoc = (user: IUser, code: string) => {
  if (user?.is_superuser) return true;
  if (!user?.roles?.length) return false;

  return user.roles.some((role) => {
    const right = adaptRightTitle(role?.right);
    const allowed = ["admin", "superuser", "editor"].includes(right);
    const matchesReg = role?.team?.regulators?.some(
      (reg) => adaptRightTitle(reg?.code) === adaptRightTitle(code),
    );

    return allowed && matchesReg;
  });
};
